import { Edit } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import {
	Contact,
	useGetAllContractorRollingNumbersLazyQuery,
} from "@repo/server-api";
import { RollingNumber } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import { useEffect, useMemo, useState } from "react";

import DialogRollingNumber from "../dialogs/DialogRollingNumber";

export default function RollingNumbers(
	props: Readonly<{
		contact: Contact | null;
		getContact: () => void;
	}>,
) {
	const [openDialog, setOpenDialog] = useState<boolean>(false);
	const [rollingNumber, setRollingNumber] = useState<RollingNumber | null>(
		null,
	);
	const [rollingNumbers, setRollingNumbers] = useState<RollingNumber[]>([]);

	const [getAllRollingNumbers] = useGetAllContractorRollingNumbersLazyQuery({
		variables: { contractorId: props.contact?.id ?? "" },
		fetchPolicy: "no-cache",
		onCompleted(data: { allContractorRollingNumbers: RollingNumber[] | null }) {
			if (data && data.allContractorRollingNumbers) {
				setRollingNumbers(data.allContractorRollingNumbers);
			}
		},
	});

	useEffect(() => {
		getAllRollingNumbers();
		 
	}, []);

	const { t } = useTranslation();

	const columns: GridColDef<RollingNumber>[] = useMemo(
		() => [
			{
				field: "type",
				headerName: t("type"),
				width: 150,
				renderCell: (params: GridCellParams) => {
					const type = params.row.type.toLocaleLowerCase();
					return t(`rollingnumber.${type}`, { ns: "enum" });
				},
			},
			{
				field: "format",
				headerName: t("format"),
				width: 150,
			},
			{
				field: "currentValue",
				headerName: t("current-value"),
				width: 150,
			},
			{
				field: "digitCount",
				headerName: t("digit-count"),
				width: 150,
			},
			{
				field: "actions",
				headerName: t("actions"),
				sortable: false,
				width: 150,
				renderCell: (params: GridCellParams) => {
					const openEdit = (rn: RollingNumber | null) => {
						setRollingNumber(rn);
						setOpenDialog(true);
					};

					return (
						<div>
							<Button
								data-testid="edit-button"
								onClick={() => openEdit(params.row)}
							>
								<Edit />
							</Button>
						</div>
					);
				},
			},
		],
		[t],
	);

	return (
		<Box sx={{ height: "100%", width: "100%" }}>
			<DataGridPremium
				getRowId={(row: RollingNumber) => (row ? row.type : "")}
				rows={rollingNumbers}
				columns={columns}
				disableRowSelectionOnClick
				className="table"
				hideFooter={true}
			/>
			<DialogRollingNumber
				refreshData={getAllRollingNumbers}
				rollingNumber={rollingNumber}
				open={openDialog}
				setOpen={setOpenDialog}
			/>
		</Box>
	);
}
